import Spinner from 'scripts/components/Spinner';
import React from 'react';

const LoadingIndicator = () => (
    <div className="spinner valign-wrapper">
        <Spinner size="small" />
    </div>
);

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./scripts/components/LoadingIndicator.js